import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';

import { HttpService } from 'app/shared/services/http.service';
import { SitesPageApiResult } from 'app/site-detail/services/api/site-api-result.types';

import { SitesRequest } from '../models/site-list';

const SITE_ENDPOINT = '/v1/site';
const MIN_SEARCH_KEYWORD_LENGTH = 3;

@Injectable({ providedIn: 'root' })
export class SitesGateway {
    private readonly httpService = inject(HttpService);

    getSites(request: SitesRequest): Promise<SitesPageApiResult> {
        return firstValueFrom(this.fetchSites(request));
    }

    private fetchSites({ offset, limit, keyword, searchToken }: SitesRequest): Observable<SitesPageApiResult> {
        const trimmedKeyword = keyword.trim();

        if (trimmedKeyword.length < MIN_SEARCH_KEYWORD_LENGTH) {
            return this.httpService.get(SITE_ENDPOINT, { offset, limit });
        }

        return this.httpService.post(
            `${SITE_ENDPOINT}/_search`,
            { keyword: trimmedKeyword, searchToken },
            { offset, limit },
        );
    }
}
